import React, { useContext } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import cx from "classnames";

import AvatarWidget from "../AvatarWidget/AvatarWidget";
import CodiaxContext from "../CodiaxContext";
import Logo from "../assets/images/CODIAX_Logo.svg";
import InfoIcon from "../../../../components/Icon/icons/general/InfoIcon";
import WeaveTopBar from "../../../../components/WeaveTopBar/WeaveTopBar";

import s from "./CodiaxHeader.module.scss";

export default function CodiaxHeader({ hideAvatar = false, showHelp = false, connect = () => {} }) {
	const { user, connectToMetamask, logout = () => {} } = useContext(CodiaxContext) || {};
	const hasAvatar = user && !hideAvatar;

	return (
		<div className={s.root}>
			<WeaveTopBar hideDatasource />

			<div className={s.titleContainer}>
				<Link to={"/codiax/data"}>
					<img src={Logo} alt="logo" className={s.logo} />
				</Link>

				<div className={s.avatarPanel}>
					{hasAvatar && (
						<AvatarWidget isConnected user={user} logout={logout} connect={() => connectToMetamask(true)} />
					)}

					{showHelp && (
						<Link to={"/codiax/help"} className={s.help}>
							<Button className={cx(s.info, "btn-border")} color="primary">
								<InfoIcon color="#52e8cd" width={16} height={16} />

								{!hasAvatar && <div className={s.buttonText}>Help</div>}
							</Button>
						</Link>
					)}
				</div>
			</div>
		</div>
	);
}
